import React from 'react';

import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

import './mobileHomeCliente.scss';

const SucursalesButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: '0.8rem',
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    color: 'white',
    backgroundColor: '#2D72B4',
    borderColor: 'white',
    width: '150px',
    fontFamily: [
      'Verdana',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    '&:hover': {
      borderColor: '#8d8d8d',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      color: 'white',
      backgroundColor: '#2D72B4',
      borderColor: 'white'
    },
    '&:focus': {
        boxShadow: 'none',
        color: 'white',
        backgroundColor: '#2D72B4',
        borderColor: 'white'
      },
  });

export const MobileHomeCliente = () => {
    return (
        <>
            <div className='mobile-cliente-container'>
                <div className='mobile-cliente-banner'>   
                    <div className='mobile-cliente-sistema'>
                        <div className='mobile-cliente-sistema-titulo'>
                            Servicios de soporte<br />nutricional<br />
                            y cuidados paliativos<br />domiciliarios.
                        </div>
                    </div>
                </div>

                <div className='mobile-cliente-texto'>
                    Nutrihome se adapta a las necesidades del paciente ofreciendo un programa de atención modulado o por prestaciones requeridas a los fines de lograr un Soporte Nutricional Domiciliario individualizado, eficiente y sin complicaciones. Estas prestaciones incluyen distintas modalidades de atención, según lo pactado con el financiador (obras sociales o prepagas).
                </div>

                <div className='mobile-cliente-secciones'>
                    <div className='mobile-cliente-seccion'>
                        <div className='mobile-cliente-seccion-titulo'>
                            ¿Qué brinda Nutrihome?
                        </div>
                        <br />
                        <div className='mobile-cliente-seccion-descripcion'>
                          Recursos técnicos y el equipamiento necesario para garantizar la máxima eficacia en la prestación de su servicio.
                        </div>
                        <a href="https://www.nutrihome.com.ar/que-brinda-nutri-home/" color="#2D72B4" underline="none" title="Leer más acerca de qué brinda Nutrihome" target="_blank">
                            <div className='mobile-cliente-seccion-link'>
                                Leer más
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2"/>
                                </svg>
                            </div>
                        </a>                                                        
                    </div>
                    <div className='mobile-cliente-seccion'>
                        <div className='mobile-cliente-seccion-titulo'>
                            Política de Calidad
                        </div>
                        <br />
                        <div className='mobile-cliente-seccion-descripcion'>
                          Nuestro propósito y compromiso es ser líderes en el suministro de servicio de alta calidad, seguros, accesibles y efectivos apara los pacientes.
                        </div>
                        <br />
                        <a href="#dv-politicas" color="#2D72B4" underline="none" title="Leer más acerca de Política de Calidad">
                            <div className='mobile-cliente-seccion-link'>
                                Leer más
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2"/>
                                </svg>
                            </div>
                        </a>
                    </div>
                    <div className='mobile-cliente-seccion'>
                        <div className='mobile-cliente-seccion-titulo'>
                          ¿Como ingresar a un paciente?
                        </div>
                        <br />
                        <div className='mobile-cliente-seccion-descripcion'>
                          Pasos a seguir para el ingreso de un paciente al sistema de soporte nutricianal domiciliario.
                        </div>
                        <a href="https://www.nutrihome.com.ar/como-ingresar-un-paciente.php" color="#2D72B4" underline="none" title="¿Cómo ingresar a un paciente?" target="_blank">
                            <div className='mobile-cliente-seccion-link'>
                                Leer más
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2"/>
                                </svg>
                            </div>
                        </a>                 
                    </div>
                    <div className='mobile-cliente-seccion'>
                        <div className='mobile-cliente-seccion-titulo'>
                          Conoce todos los servicios
                        </div>
                        <br />
                        <div className='mobile-cliente-seccion-descripcion'>
                          Descarga el vademecúm completo.
                        </div>
                        <a href="https://www.nutrihome.com.ar/wp-content/uploads/2020/05/vademecum_2020.pdf" color="#2D72B4" underline="none" title="Vademecum" target='_blank'>
                            <div className='mobile-cliente-seccion-link'>
                                Descargar
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 11L5 6.00545L1 1" stroke="#2D72B4" stroke-width="2"/>
                                </svg>
                            </div>
                        </a>                
                    </div>
                </div>

                <div id="dv-profesionales" className='mobile-cliente-profesionales'>
                    <div className='mobile-cliente-profesionales-texto'>
                        Cubrimos todos los aspectos de la práctica a través de nuestros equipos de profesionales especializados.
                    </div>
                </div>

                <div id="dv-politicas" className='mobile-cliente-politicas'>
                    <div className='mobile-cliente-politicas-titulo'>
                        Política de Calidad
                    </div>
                    <div className='mobile-cliente-politicas-texto'>
                        Nuestro propósito y compromiso es ser líderes en el suministro de servicios de soporte nutricional y cuidados de la salud de alta calidad, seguros, accesibles y efectivos para los pacientes.
                        <br /><br />
                        <strong>Llevamos a cabo este compromiso con la finalidad de:</strong>
                    </div>
                    <div className='mobile-cliente-politicas-texto'>
                        <ul>
                        <li>Adoptar las expectativas de los clientes, usuarios y los requerimientos aplicables y al mismo tiempo cumplirlas o superarlas constantemente, optimizando nuestros procesos y servicios.</li>
                        <li>Monitorear continuamente la seguridad del paciente y la efectividad de los servicios prestados.</li>
                        <li>Mantener un Sistema de Gestión de la Calidad transparente, bien documentado, controlado y conforme a la normativa, mejorando continuamente su idoneidad, adecuación y eficacia.</li>
                        <li>Contar con una organización competente y bien capacitada con responsabilidades y autoridades claramente definidas.</li>
                        <li>Perseguir la mejora continua y la gestión efectiva de riesgos e información.La calidad de nuestros servicios, el cumplimiento del Sistema de Gestión de la Calidad y los valores de la organización son responsabilidad de cada empleado.</li>
                        </ul>                              
                    </div>
                </div>

                <div className='mobile-cliente-newsletter'>
                    <div className='mobile-cliente-newsletter-titulo'>
                        Newsletter
                    </div>
                    <div className='mobile-cliente-newsletter-texto'>
                        Suscribite a nuestros newsletter para recibir las novedades de marketing y promociones de Nutrihome. Simplemente completá el formulario indicando tu correo electrónico.
                        <br /><br />
                        <a href="https://www.nutrihome.com.ar/legales/" style={{ color: '#2D72B4', fontSize: '14px', fontWeight: 700, textDecoration: 'underline'}} title="Términos y Condiciones" target='_blank'>Ver términos y condiciones.</a>
                    </div>
                </div>

                <div className='mobile-cliente-donde'>
                    <div className='mobile-cliente-donde-titulo'>
                        ¿Dónde estamos?
                    </div>
                    <div className='mobile-cliente-donde-texto'>
                        Estamos presentes en todo el país. Para conocer la sucursal más cercana a tu domicilio simplemente hace click en "Ver Sucursales".
                        <br /><br />
                        <SucursalesButton variant="outlined" href="https://www.nutrihome.com.ar/sucursales/" target="_blank" title='Ver Sucursales'>VER SUCURSALES</SucursalesButton>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileHomeCliente;